import React, { Component } from "react";
import { connect } from "react-redux";
import Request from "../../request";
import {
    FaFileInvoiceDollar, FaClipboardCheck, FaTimesCircle, FaClock, FaRegSadCry, FaPhoneSlash, FaExclamationTriangle,
    FaSkull, FaUsers, FaUserClock, FaPhoneAlt, FaPauseCircle, FaRegMeh, FaQuestionCircle, FaBriefcase, FaUserTimes,
    FaHandPointRight, FaCheckDouble, FaHandsHelping, FaRegSmileBeam, FaExchangeAlt
} from 'react-icons/fa';
import { Row, Col, Card, Drawer } from "antd";
import ListDrawer from './list';
import common from '../common.less'
import LatestFollowUp from "../../components/_utils/latestFollowup";
import moment from "moment";
import { TableComp } from "sz-react-utils";



const visaStatusMeta = {
    "Refund Waiting": {
        icon: <FaFileInvoiceDollar />,
        color: "bg-color-1"
    },
    "Visa Approved": {
        icon: <FaClipboardCheck />,
        color: "bg-color-2"
    },
    "Visa Refused": {
        icon: <FaTimesCircle />,
        color: "bg-color-3"
    },
    "Visa Waiting": {
        icon: <FaClock />,
        color: "bg-color-4"
    }
};


const followUpStatusMeta = {
    "Not Interested": {
        icon: <FaRegSadCry />,
        color: "bg-color-red",
    },
    "Didn't Pick up Call": {
        icon: <FaPhoneSlash />,
        color: "bg-color-orange",
    },
    "Number out of service": {
        icon: <FaExclamationTriangle />,
        color: "bg-color-dark-red",
    },
    "Dead": {
        icon: <FaSkull />,
        color: "bg-color-dark-red",
    },
    "Active": {
        icon: <FaUsers />,
        color: "bg-color-blue",
    },
    "Busy, Call Later": {
        icon: <FaUserClock />,
        color: "bg-color-yellow",
    },
    "Number not connected": {
        icon: <FaPhoneAlt />,
        color: "bg-color-grey",
    },
    "Out Of town": {
        icon: <FaPauseCircle />,
        color: "bg-color-orange",
    },
    "Cold": {
        icon: <FaRegMeh />,
        color: "bg-color-grey",
    },
    "Untouched": {
        icon: <FaQuestionCircle />,
        color: "bg-color-grey",
    },
    "Job": {
        icon: <FaBriefcase />,
        color: "bg-color-blue",
    },
    "OBD Call - Not interested": {
        icon: <FaUserTimes />,
        color: "bg-color-red",
    },
    "Another query": {
        icon: <FaHandPointRight />,
        color: "bg-color-blue",
    },
    "Commission Done": {
        icon: <FaCheckDouble />,
        color: "bg-color-green",
    },
    "Spouse Visa": {
        icon: <FaHandsHelping />,
        color: "bg-color-blue",
    },
    "OBD Call - Interested": {
        icon: <FaRegSmileBeam />,
        color: "bg-color-green",
    },
    "Final Decision Pending": {
        icon: <FaExclamationTriangle />,
        color: "bg-color-yellow",
    },
    "B2B": {
        icon: <FaExchangeAlt />,
        color: "bg-color-blue",
    }
};


class VisitorVisaLeads extends Component {
    state = {
        visible: true,
        data: [],

    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose();
        }, 500)
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    componentDidMount() {
        let { leads: { data } } = this.props
        this.setState({ data })
    }

    render() {
        let { visible } = this.state;
        let { leads: { data, count, title } } = this.props
        const columns = [
            {
                title: "ID",
                key: "id",
                dataIndex: "id",
            },
            {
                title: "Applicant Name",
                key: "applicantName",
                dataIndex: "applicantName",

            },
            {
                title: "Counsellor",
                key: "counsellorName",
                dataIndex: "counsellorId.name",
            },
            {
                title: "Conact",
                key: "mobwap",
                dataIndex: "mobwap",
                render: (val, record) => {
                    return (
                        <div>{record.countryCode ? `${record.countryCode}-` : null}{record.mobileNumber ? record.mobileNumber : ""}</div>
                    )
                },
            },
            {
                title: "Follow Up",
                key: "followUp",
                dataIndex: "followUp",
                render: (text, record) => {
                    return <LatestFollowUp info={text} />;
                },
            },
            {
                title: "Source",
                key: "source",
                dataIndex: "source"
            },
            {
                title: "Last Updated By",
                key: "updatedByUser",
                dataIndex: "updatedByUser",
                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>
                                {record.updatedByUser
                                    ? record.updatedByUser.name
                                    : record.createdByUser
                                        ? record.createdByUser.name
                                        : ""}
                            </div>
                            <small>{text ? moment(text.time).format("lll") : ""}</small>
                        </div>
                    );
                },
            },
        ];
        return (
            <Drawer
                title={`${title}:- ${count}`}
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={800}>
                <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        dataSource={data}
                        // extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </Drawer>
        )
    }
}


class VisaFillingDashboard extends React.Component {
    state = {
        drawer: false,
        drawerParam: {},
        visitorLeads: {},
        visitorVisaLeadsDrawer: false,
        followupsCount: {
            "Not Interested": { total: 0, arr: [] },
            "Didn't Pick up Call": { total: 0, arr: [] },
            "Number out of service": { total: 0, arr: [] },
            "Dead": { total: 0, arr: [] },
            "Active": { total: 0, arr: [] },
            "Busy, Call Later": { total: 0, arr: [] },
            "Number not connected": { total: 0, arr: [] },
            "Out Of town": { total: 0, arr: [] },
            "Cold": { total: 0, arr: [] },
            "Untouched": { total: 0, arr: [] },
            "Job": { total: 0, arr: [] },
            "OBD Call - Not interested": { total: 0, arr: [] },
            "Another query": { total: 0, arr: [] },
            "Commission Done": { total: 0, arr: [] },
            "Spouse Visa": { total: 0, arr: [] },
            "OBD Call - Interested": { total: 0, arr: [] },
            "Final Decision Pending": { total: 0, arr: [] },
            "B2B": { total: 0, arr: [] },
        },
        newFiles: {
            "Today": { total: 0, arr: [] },
            "Yesterday": { total: 0, arr: [] },
            "Week": { total: 0, arr: [] },
            "Month": { total: 0, arr: [] },
        },
        visitorFiles: {
            "Today": { total: 0, arr: [] },
            "Yesterday": { total: 0, arr: [] },
            "Week": { total: 0, arr: [] },
            "Month": { total: 0, arr: [] },
        },
        visaDeskStatus: {
            'Refund Waiting': { total: 0, arr: [] },
            'Visa Approved': { total: 0, arr: [] },
            'Visa Refused': { total: 0, arr: [] },
            'Visa Waiting': { total: 0, arr: [] }
        }
    }



    mergeStatus(defaultObj, apiObj = {}) {
        let result = { ...defaultObj };

        Object.keys(apiObj).forEach(key => {
            if (result[key]) {
                result[key] = {
                    ...result[key],
                    ...apiObj[key]
                };
            }
        });

        return result;
    }

    loadAllApis = async (params = {}) => {

        let response = await Request.getVisaFillingDashboardData();

        this.setState({
            ...response,
            newFiles: this.mergeStatus(this.state.newFiles, response.newFiles),
            visitorFiles: this.mergeStatus(this.state.visitorFiles, response.visitorFiles),
            visaDeskStatus: this.mergeStatus(this.state.visaDeskStatus, response.visaDeskStatus),
            followupsCount: this.mergeStatus(this.state.followupsCount, response.followupsCount),
        });
    };


    componentDidMount() {
        this.loadAllApis()
    }

    render() {
        let { drawer, drawerParam, visaDeskStatus, followupsCount, visitorVisaLeadsDrawer, visitorLeads, } = this.state
        return (
            <div className="fod-container">
                {drawer && <ListDrawer param={drawerParam} onClose={() => this.setState({ drawer: false })} />}
                {visitorVisaLeadsDrawer && visitorLeads.data &&
                    <VisitorVisaLeads
                        leads={visitorLeads}
                        onClose={() => this.setState({ visitorVisaLeadsDrawer: false })}
                    />
                }

                <Row className="fod-row">
                    {/* Study */}
                    <Col span={8}>
                        <Card title="New Files" style={{ marginTop: 15 }}>
                            {Object.keys(this.state.newFiles).map((key) => {
                                const item = this.state.newFiles[key];
                                return (
                                    <div
                                        key={key}
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            padding: "8px 0",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "15px"
                                        }}
                                    >
                                        {/* Left Side: Title */}
                                        <span title={key}>{key}</span>

                                        {/* Right Side: Clickable Count */}
                                        <span
                                            style={{ color: "#1890ff", cursor: "pointer", fontWeight: 600 }}
                                            onClick={() =>
                                                this.setState({
                                                    drawer: true,
                                                    drawerParam: {
                                                        title: key + " Visa Files",
                                                        arr: item.arr,
                                                        count: item.total
                                                    }
                                                })
                                            }
                                        >
                                            {item.total}
                                        </span>
                                    </div>
                                );
                            })}
                        </Card>

                    </Col>

                    {/* Visitor */}
                    <Col span={8}>
                        <Card title="New Visitor Files" style={{ marginTop: 15 }}>
                            {Object.keys(this.state.visitorFiles).map((key) => {
                                const item = this.state.visitorFiles[key];
                                return (
                                    <div
                                        key={key}
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            padding: "8px 0",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "15px"
                                        }}
                                    >
                                        <span title={key}>{key}</span>

                                        <span
                                            style={{ color: "#1890ff", cursor: "pointer", fontWeight: 600 }}
                                            onClick={() =>
                                                this.setState({
                                                    visitorVisaLeadsDrawer: true,
                                                    visitorLeads: {
                                                        title: `${key} Visitor Visa Files`,
                                                        data: item.arr,
                                                        count: item.total
                                                    }
                                                })
                                            }
                                        >
                                            {item.total}
                                        </span>
                                    </div>
                                );
                            })}
                        </Card>
                    </Col>

                </Row>

                <Card title="Visa File Status" style={{ marginTop: 10 }}>
                    <Row className="fod-row">

                        {Object.keys(visaDeskStatus).map((key) => {
                            const item = visaDeskStatus[key];
                            const meta = visaStatusMeta[key] || {};

                            return (
                                <Col span={6} key={key}>
                                    <div className="info-box glass">
                                        <span className={`info-box-icon ${meta.color} elevation-1`}>
                                            {meta.icon}
                                        </span>

                                        <div className="info-box-content">
                                            <span className="info-box-text" title={key}>{key}</span>

                                            <span className="info-box-number">
                                                <a onClick={() =>
                                                    this.setState({
                                                        drawer: true,
                                                        drawerParam: {
                                                            title: key,
                                                            arr: item.arr,
                                                            count: item.total
                                                        }
                                                    })
                                                }>
                                                    {item.total}
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </Col>
                            );
                        })}

                    </Row>
                </Card>

                <Card title="Follow Ups" style={{ marginTop: 10 }}>
                    <Row className="fod-row">

                        {Object.keys(followupsCount).map((key) => {
                            const item = followupsCount[key];
                            const meta = followUpStatusMeta[key] || {};

                            return (
                                <Col span={6} key={key}>
                                    <div className="info-box glass">

                                        <span className={`info-box-icon ${meta.color} elevation-1`}>
                                            {meta.icon}
                                        </span>

                                        <div className="info-box-content">
                                            <span className="info-box-text" title={key}>{key}</span>

                                            <span className="info-box-number">
                                                <a
                                                    onClick={() =>
                                                        this.setState({
                                                            drawer: true,
                                                            drawerParam: {
                                                                title: key,
                                                                arr: item.arr,
                                                                count: item.total
                                                            }
                                                        })
                                                    }
                                                >
                                                    {item.total}
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </Col>
                            );
                        })}

                    </Row>
                </Card>
            </div>
        );
    }
}



const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(mapDispatchToProps)
    (VisaFillingDashboard)